<template>
  <div class="sb-out-box">
      <div class="sb-top-box">

        <div class="logo" @click="toHome()">
          <img class="logo-img" :src="logourl"/>
        </div>
        <div class="s-title">{{menutitle}}</div>
        <!-- <div>
          <router-link class="inlineBlock" to="/home">
            <el-button class="s-btn" icon="el-icon-s-home">首页</el-button>
          </router-link>
        </div> -->

        <div v-if="getMenus('planadd')">
          <router-link class="inlineBlock" to="/plan/addPlan">
            <el-button class="s-btn" icon="el-icon-circle-plus">新增计划</el-button>
          </router-link>
        </div>

      </div>


      <scroll-bar class="sb-down-box">
        <!-- <router-link class="inlineBlock" to="/home">
          <el-button type="primary">首页</el-button>
        </router-link> -->
        <el-menu
          mode="vertical"
          :show-timeout="200"
          :default-active="$route.path"
          :collapse="isCollapse"
          text-color="#191919"
          active-text-color="#fff"
        >
          <sidebar-item :routes="routes"></sidebar-item>
        </el-menu>
      </scroll-bar>


  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'
import logo_icon from '@/assets/images/logo2.png'
import { isMenus } from "@/utils/auth";
import { getMyEmployer } from "@/api/seting";

export default {
  data() {
      return {
        menutitle: process.env.BASE_TITLE,
        logourl:logo_icon
      }
    },
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters(['menus',
      'sidebar',
      'routers'
    ]),
    routes() {
      // return this.$router.options.routes
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  created() {
    this.getLogo(); 
  },
  methods: {
      getMenus(m){
       return   isMenus(m,this.menus);
      },
      toHome(){
        this.$router.push({ path:'/home'  })
      },
      getLogo(){
        getMyEmployer().then((response) => {
        if(response.data.osslogourl) {
          this.logourl = response.data.osslogourl;
        }
      });
      }
  }
}
</script>

<style lang="scss">

  .sb-out-box{
    display: flex;
    flex-direction: column;
    background: linear-gradient(180deg, #A2BEFF 0%, #FFFFFF 100%);
    height: 100vh;
    .sb-top-box{
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 22px 0 25px 0;
      box-shadow: 0 30px 30px -20px rgba(73,84,163,0.25);
      .logo{
        width: 120px;
        height: 120px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .logo-img{
        	max-width: 100%;
        	max-height: 100%;
        }
      }
      .s-title{
      	font-size: 12px;
      	color: #191919;
      	line-height: 2.4;
      	border-top: 1px solid rgba(255,255,255,0.5);
      	letter-spacing: 5px;
      	margin-top: 12px;
      }
      .s-btn{
        background-color: #4f56c2;
        color: #fff;
        border: none;
        margin: 15px 0 0 0;
        width: 140px;
        &:hover{
          background-color: #5e66d9;
        }
      }
    }
    .sb-down-box{
      background: none !important;
      flex: 1;
      overflow: hidden;
      // border-top: 1px solid rgba(255,255,255,0.5);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue